module.exports = __webpack_public_path__ + "2133cad1c28bd7e96a1a4861716b778e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plaisirs-gastronomiques/01.jpg
// module id = mrVK
// module chunks = 0